/* UL-2026 · Drop lateral del home.
   Los clips rotan solos a intervalo fijo. La música de hover la aporta
   ul-theme.js, que engancha cualquier elemento con
   data-product-handle="deckard-biker-boots". */

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
/* En táctil no hay "fuera": el panel ocupa casi toda la pantalla y el único
   cierre fiable es la X. El clic fuera se limita a puntero fino. */
const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

/* ?drop=1 fuerza el banner aunque ya se haya cerrado (útil para revisar).
   ?drop=0 olvida el cierre y lo deja como si fuera la primera visita. */
const DROP_PARAM = new URLSearchParams(window.location.search).get('drop');

function setupDrop(root) {
  if (root.dataset.ulDropReady === 'true') return;
  root.dataset.ulDropReady = 'true';

  const videos = [...root.querySelectorAll('.ul-drop__video')];
  const closeButton = root.querySelector('[data-ul-drop-close]');
  const storageKey = root.dataset.dropKey || 'ul-drop';
  const dropKind = root.dataset.dropKind || 'default';
  const gateKey = root.dataset.dropGate || '';
  const interval = Number(root.dataset.dropInterval) || 2000;
  if (!videos.length && dropKind !== 'sale') return;

  let current = videos.findIndex((video) => video.classList.contains('is-active'));
  if (current < 0 && videos.length) current = 0;
  let timer = null;
  let switching = false;

  const remembered = () => {
    if (DROP_PARAM === '1') return false;
    if (DROP_PARAM === '0') {
      try { window.sessionStorage.removeItem(storageKey); } catch { /* sin storage */ }
      return false;
    }
    try { return window.sessionStorage.getItem(storageKey) === 'closed'; }
    catch { return false; }
  };

  const remember = () => {
    try { window.sessionStorage.setItem(storageKey, 'closed'); } catch { /* sin storage */ }
  };

  const gateIsOpen = () => {
    if (!gateKey || DROP_PARAM === '1') return true;
    try { return window.sessionStorage.getItem(gateKey) === 'closed'; }
    catch { return false; }
  };

  /* Elige un clip al azar distinto del que se está viendo. */
  const pickRandom = () => {
    if (videos.length < 2) return 0;
    let next = current;
    while (next === current) next = Math.floor(Math.random() * videos.length);
    return next;
  };

  const warm = (index) => {
    const video = videos[index];
    if (!video || video.dataset.ulWarmed === 'true') return;
    // Subir preload a 'auto' ya inicia la descarga. Llamar además a load()
    // reiniciaba la carga y el navegador pedía el mismo mp4 dos veces.
    video.dataset.ulWarmed = 'true';
    if (video.preload === 'none') video.preload = 'auto';
    if (video.readyState === 0) video.load();
  };

  const nextPaint = () => new Promise((resolve) => {
    window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
  });

  /* Prepara y decodifica el primer cuadro antes de retirar el clip visible.
     Así el cambio es un corte directo y nunca se descubre el fondo del panel. */
  const show = async (index) => {
    const next = ((index % videos.length) + videos.length) % videos.length;
    if (next === current || switching) return;
    switching = true;

    const incoming = videos[next];
    const outgoing = current >= 0 ? videos[current] : null;
    warm(next);

    try {
      await incoming.play();
      await nextPaint();
      incoming.classList.add('is-active');
      outgoing?.classList.remove('is-active');
      if (outgoing && !outgoing.paused) outgoing.pause();
      current = next;
    } catch {
      // Si el navegador todavía no puede reproducirlo, se conserva intacto
      // el cuadro anterior y se intenta otro clip en el siguiente intervalo.
      incoming.pause();
    } finally {
      switching = false;
    }
  };

  const startRotation = () => {
    if (timer || videos.length < 2) return;
    timer = window.setInterval(() => show(pickRandom()), interval);
  };

  const stopRotation = () => {
    window.clearInterval(timer);
    timer = null;
  };

  const close = () => {
    stopRotation();
    videos.forEach((video) => video.pause());
    root.classList.remove('is-open');
    remember();
    window.setTimeout(() => { root.hidden = true; }, REDUCED.matches ? 0 : 640);
  };

  const open = () => {
    root.hidden = false;
    // Forzar un reflujo garantiza que la transición arranque desde el estado
    // inicial. requestAnimationFrame no sirve aquí: no se ejecuta si la
    // pestaña está en segundo plano y la barra se quedaría fuera de pantalla.
    void root.offsetWidth;
    root.classList.add('is-open');
    // Deckard cuenta como visto al aparecer. Así solo se muestra una vez por
    // sesión, independientemente de si la primera aparición ocurre en el home
    // o en una grilla de colección.
    if (dropKind === 'deckard') remember();
    if (videos.length) {
      warm(current);
      const initialPlay = videos[current].play();
      if (initialPlay && typeof initialPlay.catch === 'function') initialPlay.catch(() => {});
      // Los clips de venta ya están optimizados (~4.3 MB en total). Calentarlos
      // al abrir evita que un cambio aleatorio llegue sin un cuadro decodificado.
      if (dropKind === 'sale') videos.forEach((_, index) => warm(index));
      if (videos.length > 1) show(pickRandom());
      startRotation();
    }
  };

  closeButton?.addEventListener('click', close);
  root.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', remember));
  if (dropKind === 'sale') window.addEventListener('pagehide', remember, { once: true });

  // Clic fuera del panel (solo desktop).
  document.addEventListener('pointerdown', (event) => {
    if (root.hidden || !FINE_POINTER.matches) return;
    if (event.composedPath().includes(root)) return;
    close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) close();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopRotation();
      videos.forEach((video) => video.pause());
    } else if (!root.hidden) {
      const played = videos[Math.max(current, 0)]?.play();
      if (played && typeof played.catch === 'function') played.catch(() => {});
      startRotation();
    }
  });

  if (remembered() || !gateIsOpen()) return;
  window.setTimeout(open, Number(root.dataset.dropDelay) || 900);
}

/* Tarjeta de Deckard en la grilla: el clip se reproduce al pasar el cursor.
   La música la sigue disparando ul-theme.js sobre el mismo elemento. */
function setupCardVideo(video) {
  const card = video.closest('[data-product-card]') || video.closest('.ul-product-card');
  if (!card || card.dataset.ulCardVideoReady === 'true') return;
  card.dataset.ulCardVideoReady = 'true';

  const play = () => {
    if (video.preload === 'none') { video.dataset.ulWarmed = 'true'; video.preload = 'auto'; }
    const played = video.play();
    if (played && typeof played.catch === 'function') played.catch(() => {});
  };

  const stop = () => {
    video.pause();
    video.currentTime = 0;
  };

  card.addEventListener('mouseenter', play);
  card.addEventListener('mouseleave', stop);
  card.addEventListener('focusin', play);
  card.addEventListener('focusout', stop);
}

function initDrops(scope = document) {
  scope.querySelectorAll('[data-ul-drop]').forEach(setupDrop);
  scope.querySelectorAll('.ul-product-card__hover-video').forEach(setupCardVideo);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initDrops());
} else {
  initDrops();
}

document.addEventListener('shopify:section:load', (event) => initDrops(event.target));
